import { getBucket, initStorage } from "../tools/conf"

const options = {
  maxSizeMB: 0.25,
}

export class FilesController {
  blobToData = (blob) => {
    return new Promise((resolve) => {
      const reader = new FileReader()
      reader.onloadend = () => resolve(reader.result)
      reader.readAsDataURL(blob)
    })
  }

  urltoFile = (url, filename, mimeType) => {
    return fetch(url)
      .then(function (res) {
        return res.arrayBuffer()
      })
      .then(function (buf) {
        return new File([buf], filename, { type: mimeType })
      })
  }

  async _handleUploadFile(bucket, file, type, folder, assetId, updateProgress, handleFinish, err, optionId, fileName) {
    let storage = initStorage(getBucket(bucket))
    let nameOfTheFile = fileName !== undefined ? fileName : file.name
    let storageRef = storage.ref(folder + "/" + nameOfTheFile)
    let url = null

    return new Promise((resolve, reject) => {
      let task = storageRef.put(file)
      task.on(
        "state_changed",
        function progress(snapshot) {
          updateProgress(type, assetId, Math.ceil((snapshot.bytesTransferred / snapshot.totalBytes) * 100))
        },
        function error(err) {
          console.log("error")
          console.log(err)
          reject(err)
        },
        async function complete() {
          url = await storageRef.getDownloadURL()
          handleFinish(type, assetId, url, optionId)
          resolve(url)
        }
      )
    })
  }

  /// NOUVEAU
}
